import React, { FC } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import { QuestionnaireDocumentDownload } from './QuestionnaireDocumentDownload';
import { Attachment } from '../../../../interfaces/Attachment';

interface Props {
  attachments: Attachment[];
  operationId?: string;
  emailReceiver?: string;
  onDocumentAction?: (type: 'view' | 'download' | 'send', attachment: Attachment, receiver?: string) => void;
}

export const QuestionnaireProductInfo: FC<Props> = ({ attachments, operationId, emailReceiver, ...props }) => {
  const productInfo = attachments?.find((attachment) => attachment.fileName?.startsWith('produktsteckbrief'));
  return (
    <QuestionnaireForm title={'Produktsteckbrief'}>
      {
        productInfo &&
        <QuestionnaireDocumentDownload
          attachment={productInfo}
          operationId={operationId}
          emailReceiver={emailReceiver}
          onDocumentAction={props.onDocumentAction}
        />
      }
    </QuestionnaireForm>
  );
};
